import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import {
  ResetPasswordGQL,
  ChangePasswordGQL
} from "../../generated/graphql";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    protected authService: NbAuthService,
    private resetPasswordGQL: ResetPasswordGQL,
    private changePasswordGQL: ChangePasswordGQL,
    private router: Router,
  )
  {}

  resetPassword(email: string){
    console.info('[AuthService] resetPassword called', {
      email,
    });

    return this.resetPasswordGQL.mutate({ email: email }).pipe(map((result) => {
      console.info('[AuthService] resetPassword GraphQL result', result);
      return result;
    }));
  }

  changePassword(oldPassword: string, newPassword: string){
    return this.changePasswordGQL.mutate({ oldPassword: oldPassword, newPassword: newPassword }).pipe(map((result) => result));
  }

  sendNotification($company_id: string[], $message: string, $subject: string, $to_dipendenti: boolean){
    return this.changePasswordGQL.mutate({ oldPassword: $message, newPassword: $subject }).pipe(map((result) => result));
    //return this.sendNotificationGQL.mutate({ company_id: $company_id, message: $message, subject: $subject, to_dipendenti: $to_dipendenti }).pipe(map((result) => result));
  }

  async getUserId(): Promise<string> {
    let token = await this.authService.getToken().toPromise();
    try{
    return token!.getPayload()['hasura_claims']['x-hasura-user-id'];
  }
    catch(err){
    this.router.navigateByUrl("/auth/login");
    return '';
    }
  }

  async getUserStatus(): Promise<string> {
    try{
    let token = await this.authService.getToken().toPromise();
    return token!.getPayload()['hasura_claims']['x-hasura-user-status'];
  }
    catch(err){
    this.router.navigateByUrl("/auth/login");
    return '';
    }
  }

  async isAdmin(): Promise<boolean> {
    let role = await this.getUserRole();
    return role === 'administrator';
  }

  async getUserRole(): Promise<string> {
    try{
    let token = await this.authService.getToken().toPromise();
    return token!.getPayload()['hasura_claims']['x-hasura-role'];
  }
    catch(err){
    this.router.navigateByUrl("/auth/login");
    return '';
    }
  }
}
